// Shared Tailwind class tokens. Kept as strings (not components) to stay light.

export const container =
  "mx-auto w-full max-w-7xl pl-[max(1.5rem,env(safe-area-inset-left))] pr-[max(1.5rem,env(safe-area-inset-right))] lg:pl-[max(2rem,env(safe-area-inset-left))] lg:pr-[max(2rem,env(safe-area-inset-right))]";

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-br from-brand-deep via-brand to-brand-cyan px-6 py-3 text-sm font-semibold text-white shadow-[0_0_24px_rgba(1,120,254,0.4)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_40px_rgba(1,120,254,0.6)] active:translate-y-0";

export const btnGhost =
  "inline-flex items-center justify-center gap-2 rounded-full border border-hairline bg-white/5 px-6 py-3 text-sm font-semibold text-fg backdrop-blur transition-all duration-300 hover:border-brand/60 hover:bg-white/10 hover:-translate-y-0.5";

export const btnGhostOnDark =
  "inline-flex items-center justify-center gap-2 rounded-full border border-white/15 bg-white/5 px-6 py-3 text-sm font-semibold text-white backdrop-blur transition-all duration-300 hover:border-brand-cyan/60 hover:bg-white/10 hover:-translate-y-0.5";

export const cardBase =
  "rounded-2xl border border-hairline bg-elevated/70 backdrop-blur transition-all duration-300";

export const eyebrow =
  "text-sm font-semibold uppercase tracking-[0.2em] text-brand";
